import { useNavigate, useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import { useFetchHeaderDetailsQuery, useUpdateHeaderMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { headerSchema } from "../configs";
import HeaderForm from "../forms/Header.form";

const EditHeaderWrapper = () => {
  const { headerId } = useParams();

  if (!headerId)
    return (
      <InfoChip severity={Severity.DANGER} content="Catégorie Introuvable" />
    );

  return <EditHeader headerId={headerId} />;
};

interface EditHeaderProps {
  headerId: string;
}

const EditHeader: React.FC<EditHeaderProps> = ({ headerId }) => {
  const [updateHeader, { isLoading }] = useUpdateHeaderMutation();
  const { data: headerDetails, isFetching } =
    useFetchHeaderDetailsQuery(headerId);
  const navigate = useNavigate();

  if (isLoading || isFetching) return <div> loading... </div>;

  if (!headerDetails)
    return (
      <InfoChip severity={Severity.DANGER} content="Catégorie Introuvable" />
    );

  return (
    <div className="w-full flex flex-col items-center p-4">
      <HeaderForm
        initialValues={headerDetails}
        validationSchema={headerSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await updateHeader({
            headerId,
            body: values,
          });
          if (!result.error) {
            showToast("Catégorie mise à jour", ToastType.SUCCESS);
            resetForm();
            navigate("/headers");
          }
        }}
      />
    </div>
  );
};

export default EditHeaderWrapper;
